import { EmailDailyStat } from 'services';
import { EMAIL_METRICS, MetricKey } from './constants';

export type EmailTotals = Record<MetricKey, number> & {
  opened_unique: number;
  clicked_unique: number;
};

export interface EmailRates {
  delivery: number;
  open: number;
  click: number;
  bounce: number;
}

const sum = (stats: EmailDailyStat[], key: keyof EmailDailyStat) =>
  stats.reduce((acc, day) => acc + ((day[key] as number) || 0), 0);

export const sumByMetric = (stats: EmailDailyStat[]): EmailTotals => {
  const totals = {} as EmailTotals;

  EMAIL_METRICS.forEach(metric => {
    totals[metric.key] = sum(stats, metric.key);
  });
  totals.opened_unique = sum(stats, 'opened_unique');
  totals.clicked_unique = sum(stats, 'clicked_unique');

  return totals;
};

const percent = (part: number, whole: number) => (whole ? (part / whole) * 100 : 0);

/**
 * Abertura e clique são calculados sobre destinatários **únicos**: o total bruto
 * conta repetições e produziria taxas acima de 100%.
 */
export const deriveRates = (totals: EmailTotals): EmailRates => ({
  delivery: percent(totals.delivered, totals.sent),
  open: percent(totals.opened_unique, totals.delivered),
  click: percent(totals.clicked_unique, totals.delivered),
  bounce: percent(totals.hard_bounced + totals.soft_bounced, totals.sent),
});
